import { makeObservable, observable } from "mobx";
import SoundClip, { ClipUIModel } from "models/SoundClip";
import BaseObjectStore, { BaseObjectStoreParams } from "../BaseObjectStore";
import type {
    ISignalsMontageCard,
    SignalsMontageResponse,
} from "../../SignalsModels";

export type MontageCardData = SignalsMontageResponse & { clip: ClipUIModel };

class MontageCardStore extends BaseObjectStore<MontageCardData, null> {
    @observable montageId: string;

    constructor({
        baseObject,
        rootStore,
        options,
        initialData,
        refreshOnCreate,
    }: BaseObjectStoreParams<MontageCardData, ISignalsMontageCard>) {
        super({
            baseObject,
            rootStore,
            options,
            initialData,
            refreshOnCreate: false,
        });
        makeObservable(this);
        this.montageId = baseObject.montageId;
        this.static = true;
        if (refreshOnCreate) {
            // Initial data fetch, we have to cancel the base object one since we need to wait for the above state first
            this.runRefresh();
        }
    }

    private buildClip(response: SignalsMontageResponse) {
        const clip = new SoundClip() as ClipUIModel;
        clip.id = this.montageId;
        clip.segmentName = response.audioName;
        clip.startTime = 0;
        return clip;
    }

    public async getData({
        abortSignal,
    }: {
        abortSignal: AbortSignal;
    }): Promise<MontageCardData> {
        const result = await this.signalsService.getSignalsMontage(
            this.montageId,
            abortSignal,
        );

        return {
            ...result,
            clip: this.buildClip(result),
        };
    }
}

export default MontageCardStore;
